import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'jhi-modal',
    template: `
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title fw-bold">{{title}}</h4>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-hidden="true"
                        (click)="dismiss()" [disabled]="disabled">
                </button>
            </div>
            <ng-content></ng-content>
        </div>
    `
})
export class ModalComponent {
    @Input() title: string;
    @Input() disabled: boolean;

    constructor(private modal: NgbActiveModal) {
    }

    dismiss() {
        this.modal.dismiss();
    }
}
